import type { TFunction } from 'i18next'

/**
 * Shared formatting helpers for notification surfaces (the bell panel and the
 * procurement catch-up inbox render the same localized titles and timestamps).
 */

/** "just now" / "5m ago" / "3h ago" / "2d ago", localized. */
export function timeAgo(dateStr: string, t: TFunction): string {
  const diff = Date.now() - new Date(dateStr).getTime()
  const mins = Math.floor(diff / 60_000)
  if (mins < 1) return t('notifications.timeAgo.justNow', 'just now')
  if (mins < 60) return t('notifications.timeAgo.minutesAgo', { count: mins, defaultValue: '{{count}}m ago' })
  const hours = Math.floor(mins / 60)
  if (hours < 24) return t('notifications.timeAgo.hoursAgo', { count: hours, defaultValue: '{{count}}h ago' })
  return t('notifications.timeAgo.daysAgo', { count: Math.floor(hours / 24), defaultValue: '{{count}}d ago' })
}

/**
 * Pick the notification text in the viewer's language, falling back to the
 * stored plain text (the emitter's source-language title/body).
 */
export function localizedText(
  i18nMap: Record<string, string> | undefined,
  fallback: string,
  lang: string,
): string {
  if (!i18nMap) return fallback
  return i18nMap[lang] ?? fallback
}

/** Cap a displayed count the way unread badges do (99+). */
export function capCount(count: number): string {
  return count > 99 ? '99+' : String(count)
}
